export const positiveGeofenceRadius = (value) => {
  const radius = Number.parseInt(value, 10)
  return Number.isFinite(radius) && radius > 0 ? radius : null
}

export function resolveReportGeofence(activity = {}) {
  const radius = positiveGeofenceRadius(activity.recorded_geo_max_distance_in_meter)

  return radius
    ? {
        radius,
        source: 'recorded',
        label: 'Radio guardado en la actividad'
      }
    : {
        radius: 100,
        source: 'fallback',
        label: 'Referencia: radio histórico no disponible'
      }
}
